import React from 'react';

import { Carousel } from 'react-responsive-carousel';
import { AiOutlineLeft } from 'react-icons/ai';
import { AiOutlineRight } from 'react-icons/ai';

import pictureCesarAtFrontDesk from '../../../../images/main/Carousel/PEWI-182 3.webp';
import picturePhysiotherapy from '../../../../images/main/Carousel/PEWI-79.webp';
import pictureRecovery from '../../../../images/main/Carousel/PEWI-152.webp';
import pictureLiftingArea from '../../../../images/main/Carousel/PEWI-193.webp';
import pictureProNutrition from '../../../../images/main/Carousel/PEWI-223.webp';
import pictureMotivationAndSlogans from '../../../../images/main/Carousel/PEWI-224.webp';
import pictureFacilities from '../../../../images/main/Carousel/IMG_6030.png';
import pictureFrontArea from '../../../../images/main/Carousel/IMG_6051.png';

import './HomeFacilities.css';

const HomeFacilities = () => {
  const facilitiesImages = [
    { src: pictureCesarAtFrontDesk, alt: 'Cesar at front desk' },
    { src: picturePhysiotherapy, alt: 'physiotherapy' },
    { src: pictureRecovery, alt: 'recovery' },
    { src: pictureLiftingArea, alt: 'lifting area' },
    { src: pictureProNutrition, alt: 'pro nutrition' },
    { src: pictureMotivationAndSlogans, alt: 'motivation & slogans' },
    { src: pictureFacilities, alt: 'facilities' },
    { src: pictureFrontArea, alt: 'front area' },
  ];

  const facilitiesSlides = facilitiesImages.map(({ src, alt }, i) => {
    return (
      <div key={i} className='carousel-slide-container'>
        <div className='carousel-img-container'>
          <img src={src} className='carousel-img' alt={alt} />
        </div>
      </div>
    );
  });

  return (
    <div className='facilities-container'>
      <div className='facilities-title'>
        <h1>OUR FACILITIES</h1>
      </div>

      <Carousel
        showArrows={true}
        autoPlay={true}
        interval={3000}
        infiniteLoop={true}
        dynamicHeight={false}
        showIndicators={false}
        showThumbs={false}
        centerMode={true}
        centerSlidePercentage={100}
        renderArrowPrev={(clickHandler, hasPrev) => {
          return (
            <div
              className='carousel-arrow-prev-container'
              onClick={clickHandler}
            >
              <AiOutlineLeft className='carousel-arrow-prev' />
            </div>
          );
        }}
        renderArrowNext={(clickHandler, hasPrev) => {
          return (
            <div
              className='carousel-arrow-next-container'
              onClick={clickHandler}
            >
              <AiOutlineRight className='carousel-arrow-next' />
            </div>
          );
        }}
        className='facilities-carousel'
      >
        {facilitiesSlides}
      </Carousel>
    </div>
  );
};

export default HomeFacilities;
